// Copyright 2021-2023 the .NET Foundation
// Licensed under the MIT License
import { __values } from "tslib";
/** Type guard function for {@link GenericSetting}. */
export function isGenericSetting(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]' &&
        obj.length == 2 &&
        typeof obj[0] === "string";
}
var appSettingTypeInfo = {
    "hideAllChrome/boolean": true,
    "selectionProximity/number": 4
};
/** Type guard function for {@link AppSetting}. */
export function isAppSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in appSettingTypeInfo);
}
/** A type-guard-like function for the app mode of {@link ModifySettingsMessage}.
 *
 * @param o An object that might be a {@link ModifySettingsMessage}
 * @returns A list of recognized {@link AppSetting}s in the message if so; otherwise null
 *
 * This function is like a type guard for the {@link ModifySettingsMessage}
 * interface, with the additional constraint that it only matches messages
 * targeting the overall app. If that is the case, it returns an array of the
 * settings that matched this package's knowledge of acceptable app settings.
 * Unrecognized settings are filtered out from the return value.
 *
 * If the message does not seem to be a settings-modification message, null is
 * returned.
 */
export function maybeAsModifiedAppSettings(o) {
    var e_1, _a;
    if (o.event !== "modify_settings" || o.target !== "app")
        return null;
    if (Object.prototype.toString.call(o.settings) !== '[object Array]')
        return null;
    var accepted = [];
    try {
        for (var _b = __values(o.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
            var item = _c.value;
            if (isGenericSetting(item) && isAppSetting(item)) {
                accepted.push(item);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return accepted;
}
//# sourceMappingURL=settings.js.map